import { useState } from 'react'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import { stopPropagation } from '../../../utils/events'
import { Widget } from '../Widget'

import { hasInfoWidgetCollapsibleFields } from './ProfileInfoWidget.utils'
import { ProfileInfoWidgetContent } from './ProfileInfoWidgetContent'
import { ProfileInfoWidgetExpandSectionsButton } from './ProfileInfoWidgetExpandSectionsButton'
import { ProfileInfoWidgetSkeleton } from './ProfileInfoWidgetSkeleton'

import * as styles from './ProfileInfoWidget.module.css'

function ProfileInfoWidget({
  NotesField,
  canEdit,
  config = EMPTY_LIST,
  data,
  isSkeleton,
  options = EMPTY_OBJECT,
  title,
  onClickEmail,
  onSubmit,
}) {
  const hasEdit = onSubmit && canEdit
  const hasHiddenSections = hasInfoWidgetCollapsibleFields({ config, data })

  const [isSectionsExpanded, setIsSectionsExpanded] = useState(false)

  function handleToggleSections(event) {
    stopPropagation(event)

    setIsSectionsExpanded(prev => !prev)
  }

  return (
    <Widget
      contentContainerProps={{
        Skeleton: ProfileInfoWidgetSkeleton,
        className: styles.content,
      }}
      headerProps={{
        contentProps: {
          actionsProps: {
            ...(hasEdit ? EMPTY_OBJECT : { EditButton: null }),
            ...(hasHiddenSections
              ? {
                  AdditionalActions: ProfileInfoWidgetExpandSectionsButton,
                  additionalActionsProps: {
                    isExpanded: isSectionsExpanded,
                    onToggle: handleToggleSections,
                  },
                }
              : EMPTY_OBJECT),
          },
        },
      }}
      isSkeleton={isSkeleton}
      title={title}
    >
      <ProfileInfoWidgetContent
        NotesField={NotesField}
        config={config}
        data={data}
        isSectionsExpanded={isSectionsExpanded}
        options={options}
        onClickEmail={onClickEmail}
        onSubmit={onSubmit}
      />
    </Widget>
  )
}

export default ProfileInfoWidget
